import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import FormControl from "@material-ui/core/FormControl";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import GoogleMapReact from "google-map-react";
import { ATHENA_VIR_PREPARE_BE, ATHENA_VIR_PREPARE_THERMEON } from "src/types/actions";
import { useForm, Controller } from "react-hook-form";
import PlacesAutoComplete from "./PlacesAutoComplete";
import { useSelector } from "react-redux";
import * as virActions from "src/actions/virActions";
import Typography from "@material-ui/core/Typography";
import Fade from "@material-ui/core/Fade";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import { useIsMount } from "src/hooks/useIsMount";
import * as appActions from "../../actions/appActions";
import useStyles from "src/layouts/DigitalVIRLayout/useStyles";
import { RoundedButton } from "@packages/ui";
import getBrandFromUrl from "src/utils/getBrandFromUrl";
import StreetviewIcon from "@material-ui/icons/Streetview";
import LocationOffIcon from "@material-ui/icons/LocationOff";
import IconButton from "@material-ui/core/IconButton";
import brandColors from "@packages/ui/theme/colors";
// import Stack from "@material-ui/core/Stack";

const googleApiKey = "AIzaSyCWBv9PQTn_fb3qCJteZ3SkfbGgtn5_-Ho";

const DigitalVIRIncidentDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const Marker = ({ text }) => (
    <div
      style={{
        fontSize: "24px",
        transform: "translate(-50%, -100%)",
        position: "absolute",
      }}
    >
      {text}
    </div>
  );

  const [location, setLocation] = useState("");
  const [isMapReady, setIsMapReady] = useState(false);
  const autoCompleteRef = useRef(null);
  const selectedVirType = useSelector((state) => state.vir?.athenaSelectedType?.selectedType);
  const selectedVirid = useSelector((state) => state.vir?.athenaSelectedId?.selectedId);
  const [showMap, setShowMap] = useState(false);
  const athenaVirDetailPatch = useSelector((state) => state.vir.athenaVirDetailPatch);
  const athenaVirDetail = useSelector((state) => state.vir.athenaVirDetail);
  const rentalData = useSelector((state) => state.vir?.virPrepareTHERMEON?.RenterDriver);
  const [formData, setFormData] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState("");
  const brand = getBrandFromUrl().toLowerCase();
  const createdBy = useSelector((state) => state.vir.athenaVirDetail?.data?.CreatedBy) || "";

  const athenaVirAuth = useSelector((state) => state.vir?.athenaVirAuth?.data);

  const [coordinates, setCoordinates] = useState({});
  const athenaSource = useSelector((state) => state.vir.athenaSource.source);

  const resubmitFlag = useSelector((state) => state.vir?.athenaVirResubmit?.flag);
  const athenaRole = useSelector((state) => state.vir?.athenaRole?.role);
  const disableEdit = resubmitFlag && athenaRole !== "staff";
  const isMount = useIsMount();
  const previousData = resubmitFlag ? athenaVirDetail?.data : athenaVirDetailPatch?.data;
  const [incidentAddress, setIncidentAddress] = useState(
    previousData?.IncidentDetails?.Address || ""
  );
  const [loading, setLoading] = useState(false);
  const [addressSource, setAddressSource] = useState("");
  useEffect(() => {
    if (previousData.IncidentDetails?.Address) {
      showPositionOnMap(previousData.IncidentDetails?.Address);
    } else {
      setCoordinates({
        lat: athenaVirAuth.latitude,
        lng: athenaVirAuth.longitude,
      });
    }
  }, []);

  useEffect(() => {
    if (!isMount) {
      if (!athenaVirDetailPatch.loading && loading) {
        setLoading(false);

        if (athenaVirDetailPatch.error) {
          dispatch(
            appActions.createToast({
              type: "error",
              message: "Failed to update",
            })
          );
        } else {
          dispatch(
            appActions.createToast({
              type: "success",
              message: "Vehicle Incident Report is updated",
            })
          );
          dispatch(
            virActions.detailVir({
              virId: selectedVirid,
            })
          );
          selectedPage(formData);
        }
      }
    }
  }, [athenaVirDetailPatch.loading]);
  const {
    handleSubmit,
    control,
    register,
    setValue,
    clearErrors,
    watch,
    formState: { errors, isDirty },
    reset,
  } = useForm({
    defaultValues: {
      question1: previousData?.CustomerDriving
        ? previousData?.CustomerDriving === "Y"
          ? "yes"
          : previousData?.CustomerDriving === "N"
          ? "no"
          : "Car was parked"
        : "yes",
      address: previousData?.IncidentDetails?.Address || "",
      incidentdatatime: previousData?.IncidentDetails?.Date,
      description: previousData?.IncidentDetails?.Description || "",
      customerPresent: previousData?.CustomerPresent === "Y" ? "yes" : "no",
    },
  });
  const description = watch("incidentDescription", "");
  const inputRef = useRef(null);
  const handleFocus = () => {
    if (inputRef.current) {
      inputRef.current.max = getMaxDateTime();
    }
  };
  const handleDateChange = (e) => {
    const value = e.target.value;
    if (value && new Date(value) > new Date()) {
      const corrected = getMaxDateTime();
      e.target.value = corrected;
      setValue("incidentdatatime", corrected, { shouldValidate: true });
    }
  };

  useEffect(() => {
    if (location && location.geometry) {
      const lat =
        typeof location.geometry.location.lat === "function"
          ? location.geometry.location.lat() // the result that reversse geocoding returns, lat() is a function
          : location.geometry.location.lat; // the result that places auto complete returns, lat is a attribute

      const lng =
        typeof location.geometry.location.lng === "function"
          ? location.geometry.location.lng()
          : location.geometry.location.lng;

      setCoordinates({
        lat: lat,
        lng: lng,
      });
    }
  }, [location]);
  const handleAccordionChange = () => {
    setShowMap((prev) => !prev);
  };
  const handleToggle = () => {
    setShowMap((prev) => !prev);
  };
  const showPositionOnMap = async (address) => {
    const list = address.split(",");
    const country = list[list.length - 1];
    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?address=${address}&key=AIzaSyCWBv9PQTn_fb3qCJteZ3SkfbGgtn5_-Ho&components=country:${country}`
      );
      const data = await res.json();
      const results = data.results;
      setLocation(results[0]);
    } catch (error) {}
  };

  useEffect(() => {
    if (selectedAddress !== "") {
      showPositionOnMap(selectedAddress);
    }
  }, [selectedAddress]);

  let controller;
  const handleMapClick = async ({ lat, lng }) => {
    setCoordinates({ lat, lng });
    if (controller) {
      controller.abort();
    }

    controller = new AbortController();
    const signal = controller.signal;

    try {
      const res = await fetch(
        `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleApiKey}`,
        { signal }
      );
      const data = await res.json();
      const results = data.results;
      //results is a array, that contains multiple locations(some are more sepefic while some are general)
      //I need the one that is most specific but not "plus_code"
      const bestAddress = results.reduce((a, b) => {
        if (b.plus_code) {
          return a;
        }

        if (a == null || b.address_components.length > a.address_components.length) {
          return b;
        }

        return a;
      }, null);

      if (bestAddress) {
        setIncidentAddress(bestAddress.formatted_address);
        setAddressSource("map");

        // Update autocomplete value
        if (autoCompleteRef.current) {
          autoCompleteRef.current.setAutoCompleteValue(bestAddress.formatted_address);
        }
      }
    } catch (error) {
      console.error("get location error:", error);
    }
  };
  const getMaxDateTime = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() - 1);
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  };
  const onSubmit = (data) => {
    setLoading(true);
    setFormData(data);

    const virPayloadBE = {};
    const virPayloadTHERMEON = {};

    const customerPresent = data.customerPresent === "yes" ? "Y" : "N";

    virPayloadTHERMEON["Date"] = data.incidentdatatime;
    virPayloadTHERMEON["Address"] = data.address;
    virPayloadTHERMEON["IncidentDescription"] = data.incidentDescription;
    if (data.question1 == "yes") {
      virPayloadTHERMEON["RenterDriver"] = "Y";
      virPayloadBE["CustomerDriving"] = "Y";
      virPayloadBE["CustomerPresent"] = "Y";
    } else if (data.question1 == "no") {
      virPayloadTHERMEON["RenterDriver"] = "N";
      virPayloadBE["CustomerDriving"] = "N";
      virPayloadBE["CustomerPresent"] = customerPresent;
    } else {
      virPayloadTHERMEON["RenterDriver"] = "N";
      virPayloadBE["CustomerDriving"] = "Car was parked";
      virPayloadBE["CustomerPresent"] = "N";
    }

    const params = {
      virId: selectedVirid,
      virStatus: resubmitFlag ? "SubmissionPage" : "IncidentDetails",
      data: {
        IncidentDetails: {
          Date: data.incidentdatatime,
          Description: data.incidentDescription,
          Address: incidentAddress || data.address,
          ...(selectedVirType === "panel" && {
            RenterDriver: virPayloadTHERMEON["RenterDriver"],
          }),
        },
        ...(selectedVirType === "panel" && {
          CustomerPresent: virPayloadBE["CustomerPresent"],
          CustomerDriving: virPayloadBE["CustomerDriving"],
        }),
      },
    };
    if (athenaSource === "sms" && isDirty) {
      params.data.CustomerEditBySms = true;
    }

    dispatch({ type: ATHENA_VIR_PREPARE_BE, payload: virPayloadBE });
    dispatch({ type: ATHENA_VIR_PREPARE_THERMEON, payload: virPayloadTHERMEON });
    // patch disptach
    dispatch(virActions.detailPatchVir(params)); // Assuming `virActions.detailPatchVir` is the correct action
  };
  const selectedPage = (data) => {
    if (!data) {
      console.error("No data provided to navigateBasedOnCondition");
      return;
    }
    if (
      selectedVirType === "windscreen" ||
      selectedVirType === "interior" ||
      selectedVirType === "mechanical"
    ) {
      navigate(`/vehicleincidents/damagedetails?brand=${brand}`);
      return;
    }
    if (data.question1 === "yes") {
      navigate(`/vehicleincidents/thirdpartydetails?brand=${brand}`);
    } else if (data.question1 === "no") {
      navigate(`/vehicleincidents/otherdriverdetails?brand=${brand}`);
    } else {
      navigate(`/vehicleincidents/thirdpartydetails?brand=${brand}`);
    }
  };
  const handleAddressChange = (address, source = "input") => {
    setIncidentAddress(address);
    setAddressSource(source);
  };

  useEffect(() => {
    if (disableEdit && previousData?.IncidentDetails?.Description) {
      setValue("incidentDescription", previousData?.IncidentDetails?.Description);
      clearErrors("incidentDescription");
    }
  }, [resubmitFlag, previousData?.IncidentDetails, setValue, clearErrors]);

  return (
    <>
      <Box
        sx={{
          p: 4,
          textAlign: "left",
          fontFamily: "Ride",
          color: "#333",
          maxWidth: "500px",
          margin: "0 auto",
        }}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <h2 className={classes.heading}>Please complete the incident details.</h2>

          <br></br>
          <hr className={classes.breakLine} style={{ borderColor: brandColors[brand] || brandColors.default }} />
          <TextField
            label="Incident date & time"
            variant="outlined"
            fullWidth
            type="datetime-local"
            margin="normal"
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              // max: new Date().toISOString().sli("T")[0],
              max: getMaxDateTime(),
            }}
            {...register("incidentdatatime", {
              required: athenaRole !== "staff" ? "Incident date & time is required" : false,
              validate: (value) => {
                if (value && new Date(value) > new Date()) {
                  return "future dates are not allowed";
                }
                return true;
              },
            })}
            onFocus={handleFocus}
            onChange={handleDateChange}
            error={!!errors.incidentdatatime}
            helperText={errors.incidentdatatime?.message}
            disabled={
              disableEdit &&
              previousData?.IncidentDetails?.Date != "" &&
              previousData?.IncidentDetails?.Date != undefined
            }
          />
          {selectedVirType === "panel" && (
            <Box sx={{ mt: 0 }}>
              <PlacesAutoComplete
                onAddressChange={(address) => handleAddressChange(address, "input")}
                ref={autoCompleteRef}
                incidentAddress={incidentAddress}
                selectedChoice={setSelectedAddress}
                {...register("address")}
                label="Incident Address"
                disabled={
                  disableEdit &&
                  previousData?.IncidentDetails?.Address != "" &&
                  previousData?.IncidentDetails?.Address != undefined
                }
              />
            </Box>
          )}

          {/* google map, drop pin */}

          <div>
            {selectedVirType === "panel" && (
              <Accordion expanded={showMap} onChange={handleAccordionChange} elevation={0}>
                <Box
                  sx={{
                    width: "100%",
                    height: "50px",
                    mt: 0,
                    pt: 0,
                    borderTop: "none",
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                    sx={{ padding: 0 }}
                  >
                    <IconButton onClick={handleToggle} style={{ padding: 0, marginRight: 4 }}>
                      {showMap ? (
                        <LocationOffIcon fontSize="small" />
                      ) : (
                        <StreetviewIcon fontSize="small" />
                      )}
                    </IconButton>
                    <Typography variant="caption" style={{ padding: 0, margin: 0 }}>
                      {showMap ? "Hide Map" : "Show Map"}
                    </Typography>
                  </AccordionSummary>
                </Box>

                <AccordionDetails style={{ display: "block" }}>
                  <Fade in={showMap}>
                    <Typography variant="caption">Click on map to get address</Typography>
                  </Fade>

                  {showMap && (
                    <div style={{ height: "300px", width: "100%" }}>
                      <GoogleMapReact
                        bootstrapURLKeys={{ key: googleApiKey, libraries: ["places"] }}
                        defaultCenter={coordinates}
                        center={coordinates}
                        defaultZoom={11}
                        onClick={handleMapClick}
                        yesIWantToUseGoogleMapApiInternals
                        onGoogleApiLoaded={({ map, maps }) => setIsMapReady(true)}
                      >
                        {coordinates && (
                          <Marker lat={coordinates.lat} lng={coordinates.lng} text="📍" />
                        )}
                      </GoogleMapReact>
                    </div>
                  )}
                </AccordionDetails>
              </Accordion>
            )}
          </div>

          <TextField
            fullWidth
            id="filled-multiline-static"
            label="Tell us what happened"
            multiline
            minRows={10}
            margin="normal"
            color="primary"
            defaultValue={
              previousData?.IncidentDetails?.Description
                ? previousData?.IncidentDetails?.Description
                : ""
            }
            variant="outlined"
            {...register("incidentDescription", {
              required: "Description is required",
              maxLength: {
                value: 500,
                message: "Description cannot exceed 500 characters",
              },
            })}
            inputProps={{ maxLength: 500 }}
            error={!!errors.incidentDescription}
            helperText={errors.incidentDescription?.message || `${description.length}/500`}
            disabled={
              disableEdit &&
              previousData?.IncidentDetails?.Description != "" &&
              previousData?.IncidentDetails?.Description != undefined
            }
          />

          <br></br>

          {selectedVirType === "panel" && (
            <FormControl component="fieldset" sx={{ mt: 2 }}>
              <FormLabel component="legend" className={classes.radioFormat}>
                Were you the driver at the time of the incident?
              </FormLabel>
              <Controller
                rules={{ required: true }}
                control={control}
                name="question1"
                defaultValue={rentalData === "Y"}
                render={({ field }) => (
                  <RadioGroup row {...field}>
                    <FormControlLabel
                      value="yes"
                      control={<Radio />}
                      label="Yes"
                      disabled={
                        disableEdit &&
                        previousData?.CustomerDriving !== "" &&
                        previousData?.CustomerDriving !== undefined &&
                        !(createdBy === "staff" && athenaRole === "customer")
                      }
                    />
                    <FormControlLabel
                      value="no"
                      control={<Radio />}
                      label="No"
                      disabled={
                        disableEdit &&
                        previousData?.CustomerDriving !== "" &&
                        previousData?.CustomerDriving !== undefined &&
                        !(createdBy === "staff" && athenaRole === "customer")
                      }
                    />
                    <FormControlLabel
                      value="Car was parked"
                      control={<Radio />}
                      label="Car was parked"
                      disabled={
                        disableEdit &&
                        previousData?.CustomerDriving !== "" &&
                        previousData?.CustomerDriving !== undefined &&
                        !(createdBy === "staff" && athenaRole === "customer")
                      }
                    />
                  </RadioGroup>
                )}
              />
              {watch("question1") === "no" && (
                <FormControl component="fieldset" sx={{ mt: 2 }}>
                  <FormLabel component="legend" className={classes.radioFormat}>
                    Were you present at the time of the incident?
                  </FormLabel>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name="customerPresent"
                    render={({ field }) => (
                      <RadioGroup row {...field}>
                        <FormControlLabel
                          value="yes"
                          control={<Radio />}
                          label="Yes"
                          disabled={
                            disableEdit &&
                            previousData?.CustomerPresent !== "" &&
                            previousData?.CustomerPresent !== undefined &&
                            !(createdBy === "staff" && athenaRole === "customer")
                          }
                        />
                        <FormControlLabel
                          value="no"
                          control={<Radio />}
                          label="No"
                          disabled={
                            disableEdit &&
                            previousData?.CustomerPresent !== "" &&
                            previousData?.CustomerPresent !== undefined &&
                            !(createdBy === "staff" && athenaRole === "customer")
                          }
                        />
                      </RadioGroup>
                    )}
                  />
                </FormControl>
              )}
            </FormControl>
          )}
          <Box sx={{ my: 3 }}>
            <div>
              <RoundedButton
                variant="contained"
                fullWidth
                sx={{ mt: 2, width: "80%", margin: "2" }}
                type="submit"
                style={{ textTransform: "none" }}
                disabled={loading}
              >
                {loading ? <CircularProgress /> : "Continue"}
              </RoundedButton>
            </div>
          </Box>
        </form>
      </Box>
    </>
  );
};

export default DigitalVIRIncidentDetails;
